export const STATUS_LABELS = { concept: 'Concept', gecontroleerd: 'Gecontroleerd', voorbeeldsetlist: 'Voorbeeldsetlist' };
export const STATUS_STYLES = {
  concept: 'bg-slate-100 text-slate-700',
  gecontroleerd: 'bg-emerald-50 text-emerald-800',
  voorbeeldsetlist: 'bg-teal-50 text-teal-800',
};

export const formatServiceDate = (value, certain = true) => {
  if (!value) return 'Datum onbekend';
  const formatted = new Date(`${value}T00:00:00`).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
  return certain ? formatted : `${formatted} (onzeker)`;
};

export const pluralize = (count, one, many) => `${count} ${count === 1 ? one : many}`;
